import { Auth0ClientInstance } from "./Auth0ClientInstance";
export class LoginTrackerService {
    static async getLoginCount() {
        try {
            const user = await Auth0ClientInstance.getUser();
            if (!user)
                return null;
            const key = Object.keys(user).find(k => k.toLowerCase().includes("logincount"));
            if (!key)
                return null;
            return user[key];
        }
        catch (_a) {
            return null;
        }
    }
}
